export enum DirectionType {
  Origin = "origin",
  Destination = "destination",
  MultiDestination = "multi",
  Charter = "charter",
}
